import {
    validationFailed,
    getFileExtension,
    createFailure,
    ValidationFailure,
    createValidationResult
} from "sprint-common-web";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { hasFileExtension } from "../../../../../orders/orders/create/common/utils/hasFileExtension";
import { isMatchingFileExtension } from "../../../../common/isMatchingFileExtension";

export const useRequestCloudFixValidation = () => {
    const { validateRequestCloudFix, validateIfObjectExists: checkObjectExistence } = useCloudFileApi();

    const validateDeliveryFilePath = async (filepath: string) => {
        if (!filepath.length) {
            const failure = createFailure("Enter file path", "filepath.Missing");

            return validationFailed([failure]);
        }

        if (!hasFileExtension(filepath)) {
            const failure = createFailure("File path should contain extension", "filepath.MissingExtension");

            return validationFailed([failure]);
        }

        if (!isMatchingFileExtension(getFileExtension(filepath))) {
            const failure = createFailure(
                "File's extension is not on list of supported video, subtitle, audio files",
                "filepath.NotSupportedExtension"
            );

            return validationFailed([failure]);
        }

        return await validateRequestCloudFix({ filename: filepath });
    };

    const validate = async (deliveryFileName: string, filePath: string) => {
        const failures: ValidationFailure[] = [];
        const objectExistingResult = await checkObjectExistence({ filePath });

        if (!objectExistingResult.isValid) {
            failures.push(
                createFailure("Cannot request cloud fix, source file does not exist in S3 Bucket", "object-missing")
            );
        }

        const deliveryPathResult = await validateDeliveryFilePath(deliveryFileName);

        failures.push(...deliveryPathResult.failures);

        return createValidationResult(failures);
    };

    return {
        validate
    };
};
